<template>
    <LayoutSub className="pb-0 about">
        <SubSection>
            <div class="title_wrap">
                <h2>
                    고객과 가맹점 간의 <span class="c-red">연결을 통해 <br />혁신적인 가치 창출</span>을 선도하는 기업
                </h2>
                <p>
                    한국정보통신은 신뢰와 고객 중심의 경영 철학을 바탕으로 국내외 결제 시장에서의 경쟁력을 강화하며 고객과 함께 성장하는 동반자가 되기
                    위해 노력하고 있습니다. <br />미래 지향적인 서비스를 통해 디지털 경제 시대를 선도하며 지속 가능한 성장을 추구하는 글로벌 결제
                    솔루션 리더로서의 역할을 다하고자 합니다.
                </p>
            </div>
        </SubSection>

        <section class="section02" data-aos="fade-up">
            <div class="left_title_area">
                <h3>기업정보</h3>
            </div>
            <div class="right_content_area">
                <div class="content">
                    <div class="content_row">
                        <div class="row_title">
                            <span>회사명</span>
                        </div>
                        <div class="row_content">
                            <p>한국정보통신주식회사<br />KOREA INFORMATION ＆ COMMUNICATIONS CO., LTD.</p>
                        </div>
                    </div>
                    <div class="content_row">
                        <div class="row_title">
                            <span>대표이사</span>
                        </div>
                        <div class="row_content">
                            <p>임명수</p>
                        </div>
                    </div>
                    <div class="content_row">
                        <div class="row_title">
                            <span>설립일</span>
                        </div>
                        <div class="row_content">
                            <p>1986년 5월 9일</p>
                        </div>
                    </div>
                    <div class="content_row">
                        <div class="row_title">
                            <span>주소</span>
                        </div>
                        <div class="row_content">
                            <p>서울특별시 중구 세종대로 39 7층 (남대문로4가, 대한상공회의소)</p>
                        </div>
                    </div>
                    <div class="content_row">
                        <div class="row_title">
                            <span>주요사업</span>
                        </div>
                        <div class="row_content">
                            <p>신용카드 부가통신업(VAN), 전자지급결제대행서비스 (PG)</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section03">
            <div class="inner">
                <h3>미션</h3>
                <div class="slogun_text_wrap">
                    <p>Total Bridging People & Shop</p>
                    <span>고객과 가맹점을 연결하여 무한한 가치를 창출하는 기업</span>
                    <div class="point_text">
                        <img src="@/assets/point_text_bg.png" alt="" />
                    </div>
                </div>
                <div class="deco_area">
                    <img src="@/assets/about_deco1.png" alt="" />
                </div>
                <div class="about_card_area">
                    <div class="about_card about_card_1">
                        <span class="about_card_title">Total</span>
                        <p class="about_card_desc">
                            무한한 사업 기회의 모색과<br />
                            이를 통한 신규 수익 모델 창출
                        </p>
                    </div>
                    <div class="about_card about_card_2">
                        <span class="about_card_title">Bridging</span>
                        <p class="about_card_desc">
                            신뢰를 바탕으로 한 긴밀한 네트워크와 중추적 역할 <br />
                            양측 커뮤니케이션을 통한 유대 관계의 형성
                        </p>
                    </div>
                    <div class="about_card about_card_3">
                        <span class="about_card_title">People & Shop</span>
                        <p class="about_card_desc">
                            당사와 당사를 둘러싼 내외부 <br />
                            모든 관계를 포함
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="section04">
            <h3>기업정신</h3>
            <p>소중하게 지켜온 한국정보통신 구성원의 5가지 정신</p>
            <div class="section04_list_wrap">
                <div class="list_item">
                    <div class="list_item_title_wrap">
                        <div class="list_item_title_icon">
                            <img src="@/assets/about_icon1.png" alt="" />
                        </div>
                        <p class="list_item_title">모두가 하나</p>
                    </div>
                    <div class="list_item_content_wrap">
                        <p>
                            한국정보통신 구성원 모두는 한 곳을 보고 달려갑니다.<br />
                            상호 간의 신뢰를 바탕으로 비전을 가슴에 품고 달성 방안을 함께 공유하며 거대한 하나가 되어<br />
                            달려갑니다. 하나라는 신념, 이것이 한국정보통신 성장의 원동력입니다.
                        </p>
                    </div>
                </div>
                <div class="list_item">
                    <div class="list_item_title_wrap">
                        <div class="list_item_title_icon">
                            <img src="@/assets/about_icon2.png" alt="" />
                        </div>
                        <p class="list_item_title">나날이 전진</p>
                    </div>
                    <div class="list_item_content_wrap">
                        <p>
                            한국정보통신 구성원 모두는 하루하루 성장해 갑니다. 자발적으로 매일의 목표를 부여하고<br />
                            몰입하며 최선을 다해 실현해 갑니다. 이렇게 이루어낸 성과가 작더라도 공하고 인정하며 <br />
                            축하해 주는 기업문화는 우리를 계속 전진할 수 있게 합니다.
                        </p>
                    </div>
                </div>
                <div class="list_item">
                    <div class="list_item_title_wrap">
                        <div class="list_item_title_icon">
                            <img src="@/assets/about_icon3.png" alt="" />
                        </div>
                        <p class="list_item_title">창의와 실천</p>
                    </div>
                    <div class="list_item_content_wrap">
                        <p>
                            한국정보통신 구성원 모두는 새로운 생각을 하고 이를 행동으로 옮깁니다.<br />
                            다수 구성원의 참여를 유도하는 바텀업(Bottom-up) 방식의 제안 제도와 다양성을 인정하는<br />
                            직장 분위기, 그리고 성과에 대한 보상은 창의와 실천을 지속하기 위한 동기를 부여해줍니다.
                        </p>
                    </div>
                </div>
                <div class="list_item">
                    <div class="list_item_title_wrap">
                        <div class="list_item_title_icon">
                            <img src="@/assets/about_icon4.png" alt="" />
                        </div>
                        <p class="list_item_title">자율과 질서</p>
                    </div>
                    <div class="list_item_content_wrap">
                        <p>
                            한국정보통신 구성원 모두는 자유롭게 자신의 일을 할 수 있습니다.<br />
                            전체조직이 공유하고 있는 가치를 전제로 자기가 하고 싶은 일을 자율적으로 수행함으로써<br />
                            더 큰 가치를 창출해 갑니다.
                        </p>
                    </div>
                </div>
                <div class="list_item">
                    <div class="list_item_title_wrap">
                        <div class="list_item_title_icon">
                            <img src="@/assets/about_icon5.png" alt="" />
                        </div>
                        <p class="list_item_title">사회 봉사</p>
                    </div>
                    <div class="list_item_content_wrap">
                        <p>
                            한국정보통신 구성원은 자발적으로 사회 공헌 활동에 참여합니다.<br />
                            사회가 발전해야 기업도 존속할 수 있음을 명심하고 상생의 정신으로 기업의 사회적 책임을<br />
                            적극적으로 수행합니다.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="history_section">
            <div class="inner">
                <div class="left_title_area">
                    <h3>역사</h3>
                </div>
                <div class="right_content_area">
                    <div class="content">
                        <div class="content_row" v-for="(item, idx) in this.data" :key="idx" :class="{ fold: activeRows.includes(idx) }">
                            <div class="row_title" @click="toggleActive(idx)">
                                <span>{{ item.year }}</span>
                            </div>
                            <div class="row_content">
                                <ul v-for="(group, idx2) in groupByYear(item.months)" :key="idx2">
                                    <li v-for="(monthItem, idx3) in group" :key="idx3">
                                        <span class="row_content_title">{{ monthItem.month }}</span>
                                        <div class="row_content_list">
                                            <p class="row_content_text" v-for="(content, idx4) in monthItem.contents.split('|')" :key="idx4">
                                                {{ content.trim() }}
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <button @click="toggleActive(idx)">
                                <img src="@/assets/history_dropdown.png" alt="" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';
import { getAboutIntroduce } from '@/api';

export default {
    components: {
        LayoutSub,
        SubSection,
    },
    data() {
        const activeRows = [1, 2, 3, 4, 5, 6, 7];

        return {
            activeRows,
            data: [],
        };
    },
    methods: {
        toggleActive(idx) {
            if (this.activeRows.includes(idx)) {
                this.activeRows = this.activeRows.filter((i) => i !== idx);
            } else {
                this.activeRows.push(idx);
            }
        },
        async getAboutIntroduce() {
            try {
                const response = await getAboutIntroduce(this.$route.query);
                this.data = response.list
                    .filter(el => el.year)
                    .reduce((acc, item) => {
                        const existingYear = acc.find((y) => y.year === item.year);
                        if (existingYear) {
                            existingYear.months.push({ month: item.month, contents: item.contents });
                        } else {
                            acc.push({ year: item.year, months: [{ month: item.month, contents: item.contents }] });
                        }
                        return acc;
                    }, [])
                    .map((yearItem) => ({
                        ...yearItem,
                        months: yearItem.months.sort((a, b) => b.month.localeCompare(a.month)),
                    }));
            } catch (err) {
                console.error(err);
                this.data = [];
            }
        },
        groupByYear(months) {
            return months.reduce((acc, monthItem) => {
                const year = monthItem.month?.split('.')[0];
                const lastGroup = acc.length > 0 ? acc[acc.length - 1] : null;

                if (lastGroup && lastGroup[0].month.startsWith(year)) {
                    lastGroup.push(monthItem);
                } else {
                    acc.push([monthItem]);
                }

                return acc;
            }, []);
        },
    },
    watch: {
        async $route() {
            await this.getAboutIntroduce();
        },
    },
    async mounted() {
        await this.getAboutIntroduce();

        document.querySelectorAll('.history_section .row_content').forEach((el) => {
            el.style.maxHeight = `${el.scrollHeight}px`;
        });
    },
};
</script>
